import { CalendarDays, CarFront, DollarSign, Settings, User } from "lucide-react";
import { ComboPropostas } from "../entities/ShopkeeperEntity";
import { colorPrimary } from "../../../theme";
import { TConcessionaria } from "../../../services";
import SpeedIcon from '@mui/icons-material/Speed';
import PodcastsIcon from '@mui/icons-material/Podcasts';
import DateRangeIcon from '@mui/icons-material/DateRange';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import FormatColorFillIcon from '@mui/icons-material/FormatColorFill';
import SensorDoorIcon from '@mui/icons-material/SensorDoor';
import SearchIcon from '@mui/icons-material/Search';
import PaidIcon from '@mui/icons-material/Paid';

export const veiculosTab = [
'Ford Fiesta Sedan 1.6 16V Flex Aut.',
'Ford EcoSport SE 1.6 16V Flex 5p Aut.',
'Fiat UNO VIVACE Celeb. 1.0 EVO F.Flex 8V 5p.',
'Fiat UNO VIVACE Celeb. 1.0 EVO F.Flex 8V 5p.',
];

export const images = [
  "https://images.unsplash.com/photo-1549924231-f129b911e442",
  "https://images.unsplash.com/photo-1619682817481-e994891cd1f5",
  "https://images.unsplash.com/photo-1553440569-bcc63803a83d",
  "https://images.unsplash.com/photo-1542362567-b07e54358753",
  "https://images.unsplash.com/photo-1511919884226-fd3cad34687c",
  "https://images.unsplash.com/photo-1503376780353-7e6692767b70",
  "https://images.unsplash.com/photo-1494976388531-d1058494cdd8",
  "https://images.unsplash.com/photo-1525609004556-c46c7d6cf023",
  "https://images.unsplash.com/photo-1605559424843-9e4c228bf1c2",
  "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf",
  "https://images.unsplash.com/photo-1542282088-fe8426682b8f",
  "https://images.unsplash.com/photo-1583121274602-3e2820c69888",
  "https://images.unsplash.com/photo-1552519507-da3b142c6e3d",
  "https://images.unsplash.com/photo-1601929862217-f1bf94503333",
  "https://images.unsplash.com/photo-1517940310602-3e7e8f6f1f9b",
  "https://images.unsplash.com/photo-1606229365485-93a3b8ee0385",
  "https://images.unsplash.com/photo-1502877338535-766e1452684a",
  "https://images.unsplash.com/photo-1610647752706-3bb12232b3ab",
  "https://images.unsplash.com/photo-1523987355523-c7b5b0dd90a7",
  "https://images.unsplash.com/photo-1549399542-7e3f8b79c341"
];


export const headerTablePropostas = [
  {id: 1, label: "Lance", icon:<DollarSign size={18} color={colorPrimary}/>},
  {id: 2, label: "Nome", icon:<User size={18} color={colorPrimary}/>},
  {id: 3, label: "Data", icon:<CalendarDays size={18} color={colorPrimary}/>},
];




export const concessionariaMock: TConcessionaria = {
  id: 1,
  grupoConcessionaria: {
    id: 100,
    grupoConcessionaria: "Grupo Auto Prime",
    logotipo: null,
    tagAtivo: "S",
    dataCadastro: "2024-06-10",
    tagTodasRevendas: "N",
    codigoMaster: 999,
    qtdeAnuncios: 245,
    status: "ATIVO",
  },
  razaoSocial: "Auto Prime Veículos LTDA",
  fantasia: "Auto Prime",
  cnpj: "12.345.678/0001-90",
  inscricaoEstadual: "123456789",
  inscricaoMunicipal: "987654321",
  telefone: "(11) 3456-7890",
  celular: "(11) 91234-5678",
  email: "contato@autoprime.com.br",
  logradouro: "Avenida Brasil",
  numeroLogradouro: "1500",
  complementoLogradouro: "Sala 302",
  bairro: "Centro",
  cep: "01000-000",
  estado: "SP",
  cidade: "São Paulo",
  responsavel: "Carlos Henrique Souza",
  logotipo: "https://via.placeholder.com/150",
  tagAtivo: "S",
  dataCadastro: "2025-01-15",
  indicacao: "Parceiro Comercial",
  observacao: "Concessionária com alto volume de vendas e bom histórico",
  tagDeferimento: "APROVADO",
  tagGrau: "A",
  textoPadrao: "Obrigado pela preferência!",
};


export const iconsIconColumn = {
  plate: <CarFront color={colorPrimary} />,
  engine: <Settings color={colorPrimary} />,
  mileage: <SpeedIcon htmlColor={colorPrimary} />,
  transmission: <PodcastsIcon htmlColor={colorPrimary} />,
  year: <DateRangeIcon htmlColor={colorPrimary} />,
  fuel: <LocalGasStationIcon htmlColor={colorPrimary} />,
  color: <FormatColorFillIcon htmlColor={colorPrimary} />,
  doors: <SensorDoorIcon htmlColor={colorPrimary} />,
  fipeCode: <SearchIcon htmlColor={colorPrimary} />,
  fipeValue: <PaidIcon htmlColor={colorPrimary} />,
};


export const vehicleAccessoriesMock: string[] = [
  "Ar-condicionado",
  "Direção hidráulica",
  "Direção elétrica",
  "Vidros elétricos",
  "Travas elétricas",
  "Alarme",
  "Rodas de liga leve",
  "Faróis de neblina",
  "Retrovisores elétricos",
  "Banco de couro",
  "Piloto automático",
  "Multimídia com Bluetooth",
  "Câmera de ré",
  "Sensor de estacionamento",
  "Chave presencial",
  "Start/Stop",
  "Controle de estabilidade",
  "Controle de tração",
  "Airbags laterais",
  "Freios ABS",
];
